import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ResourcePool from "./ResourcePool";
import {Button, Radio} from 'antd';

export default class ResourcePoolDemo extends Component{
	 constructor(props) {
		  super(props);
		  this.state={
			  dataSource:[{
			  	title:'dasdasdsad',
				  checked:false,
				  fileType:'file'
			  },
			  {
				  title:'图片',
				  checked:false,
				  fileType:'img',
				  img:'/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
			  },
			  {
				  title:'音频',
				  checked:false,
				  fileType:'audio',

			  }, {
				  title:'视频',
				  checked:false,
				  fileType:'video',
			  },{
					  title:'dasdasdsad',
					  checked:false,
					  fileType:'file'
				  },
				  {
					  title:'图片',
					  checked:false,
					  fileType:'img',
					  img:'/storage/DFCBEA29DA0EBDA07E62AAD26C094170/small/quality'
				  },
				  {
					  title:'音频',
					  checked:false,
					  fileType:'audio',

				  }, {
					  title:'视频',
					  checked:false,
					  fileType:'video',
				  },
			  ],
			  type:'small',
			  value:1,
		  }
	 }
	 render() {

		 return(

		 <div >
			 <div style={{textAlign:'center',lineHeight:'100px'}}>
				 <Radio.Group onChange={this.onChange} value={this.state.type}>
					 <Radio value={'small'}>小图标</Radio>
					 <Radio value={'middle'}>中图标</Radio>
					 <Radio value={'big'}>大图标</Radio>
					 <Radio value={'list'}>列表</Radio>
				 </Radio.Group>
			 </div>
			 <div style={{textAlign:'center',lineHeight:'100px'}}>
				 <Radio.Group onChange={this.onChangeRadio} value={this.state.value}>
					 <Radio value={1}>单选</Radio>
					 <Radio value={2}>多选</Radio>
					 <Radio value={3}>全选</Radio>
					 <Radio value={4}>反选</Radio>
				 </Radio.Group>
			 </div>
             <div >
				 {
				 this.state.dataSource.map((item,index)=>{
					 return( < ResourcePool key={index} type={this.state.type} title={item.title} img={item.img} checked={item.checked}  fileType={item.fileType} singleClick={()=>this.singleClick(index,item)} doubleClick={()=>{console.log('双击')}}/>)
				 })
			 }
			 </div>
		 </div>
		 )
	 }
	onChange = e => {
		this.setState({
			type: e.target.value,
		});
	};
	onChangeRadio = e =>{
		//全选
		if(e.target.value===3){
			this.allCheck()
		}else if(e.target.value===4){
			this.antiElection()
		}
		this.setState({value: e.target.value})
	};
	singleClick(index,item){
		if(this.state.value === 1){
           this.oneCheck(index,item)
		}else if(this.state.value ===2){
           this.moreCheck(index,item)
		}else if(this.state.value ===3||this.state.value ===4){
			this.state.value=1;
			this.oneCheck(index,item)
		}
	}
	//单选，
	oneCheck(index,item){
		this.state.dataSource.forEach(i=>{
			i.checked = false;
		});
		this.state.dataSource[index].checked = !item.checked;
		this.setState({})
	}
	//多选
	moreCheck(index,item){
		let num = 0;
		this.state.dataSource[index].checked = !item.checked;

		this.state.dataSource.forEach(i=>{
			 if(i.checked === true){
			 	num++

				 // this.setState({value:3})
			 }
			 console.log(num)
		});
		if(num===this.state.dataSource.length){
			this.state.value=3;
		}
		this.setState({})
	}
	//全选
	allCheck(){
			this.state.dataSource.forEach(i=>{
				i.checked = true;
			});
		this.setState({})
	}
	//反选
	antiElection(){
		this.state.dataSource.forEach(i=>{
			i.checked = !i.checked;
		});
		this.setState({})
	}
}